import { FC } from 'react';
import useSecurityExposures from './hooks/useSecurityExposures';
import { Insights } from '../../types/Insights';
import { DonutChart, LayoutCarousel } from '@silverfort/sf-components';

interface Props {
    insights: Insights;
    isLoading: boolean;
    isEmpty: boolean;
}

const SecurityExposuresCard: FC<Props> = ({ insights, isLoading, isEmpty }) => {
    const securityExposures = useSecurityExposures(insights, isEmpty);
    return (
        <LayoutCarousel
            title="Enrollment Status"
            contentClassName="flex flex-1 flex-col justify-center px-6"
            pages={<DonutChart data={securityExposures} isMappingVisible isLoading={isLoading} />}
        />
    );
};

export default SecurityExposuresCard;
